/* RamanRasa — pre-checkout free-shipping nudge (2026-09-14)
   Markup + data: snippets/rr-freeship-nudge.liquid (rendered from layout/theme.liquid).
   Intercepts:  cart page   button[name="checkout"]  (sections/cart-template.liquid)
                mini-cart   a.js-cart-btn-checkout   (snippets/block-cart.liquid, cross-sell.liquid)
                legacy      a.rr-cart-drawer__checkout-btn (assets/rr-cart-add.js — no longer loaded
                            by any rendered block, kept in the selector as a safety net)
   Rule: if cart.total_price < threshold (cents) → open the modal instead of leaving.
         Threshold is inclusive: exactly the threshold ships free, so no nudge at that total.
   Shown at most once per browser session (sessionStorage 'rr_nudge_seen') so a customer who
   declines is not nagged again from the mini-cart.
   Debug: ?rr_nudge_test=<cents> opens the modal on load with a fake cart of that total
   (and a fake cinnamon line so the pairing suggestion path is exercised). Never changes the real cart.
*/
(function () {
  'use strict';
  if (window.__rrNudgeInit) return;
  window.__rrNudgeInit = true;

  var root = document.getElementById('rr-nudge');
  if (!root) return;

  var dataEl = document.getElementById('rr-nudge-products');
  var data = { pairs: {}, products: [] };
  try { data = JSON.parse(dataEl.textContent); } catch (e) { /* keep empty */ }

  var THRESHOLD = parseInt(root.getAttribute('data-threshold-cents'), 10) || 5000;
  var CHECKOUT_URL = root.getAttribute('data-checkout-url') || '/checkout';
  var HEADING = root.getAttribute('data-heading') || "Just {amount} away from free US shipping";
  var ADD_LABEL = root.getAttribute('data-add-label') || 'Add & continue';
  var CONTINUE_LABEL = root.getAttribute('data-continue-label') || 'No thanks, continue to checkout';
  var SEEN_KEY = 'rr_nudge_seen';

  var titleEl = document.getElementById('rr-nudge-title');
  var listEl = document.getElementById('rr-nudge-list');
  var statusEl = document.getElementById('rr-nudge-status');
  var continueEl = document.getElementById('rr-nudge-continue');
  var panel = root.querySelector('.rr-nudge__panel');
  var lastFocus = null;
  var testMode = false;

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + v.replace(/\.00$/, '');
  }

  function seen() {
    try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; }
  }
  function markSeen() {
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) { /* ignore */ }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* Pick up to 2 purchasable suggestions (2, not 3, keeps the sheet short on phones): partner of each cart line first, then the fallback list. */
  function suggestionsFor(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.handle] = true; });
    var byHandle = {};
    data.products.forEach(function (p) { byHandle[p.handle] = p; });
    var picked = [], used = {};
    function push(p) {
      if (!p || used[p.handle] || inCart[p.handle] || picked.length >= 2) return;
      used[p.handle] = true; picked.push(p);
    }
    (cart.items || []).forEach(function (it) { push(byHandle[data.pairs[it.handle]]); });
    data.products.forEach(push);
    return picked;
  }

  function esc(s) {
    var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML;
  }

  function render(cart) {
    var gap = Math.max(0, THRESHOLD - (cart.total_price || 0));
    titleEl.textContent = HEADING.replace('{amount}', money(gap));
    continueEl.textContent = CONTINUE_LABEL;
    continueEl.setAttribute('href', CHECKOUT_URL);
    statusEl.hidden = true; statusEl.textContent = '';

    var items = suggestionsFor(cart);
    if (!items.length) {
      listEl.innerHTML = '';
      listEl.hidden = true;
      continueEl.textContent = 'Continue to checkout';
      return;
    }
    listEl.hidden = false;
    listEl.innerHTML = items.map(function (p) {
      var closes = (cart.total_price || 0) + p.priceCents >= THRESHOLD;
      return '' +
        '<li class="rr-nudge__item">' +
          '<a class="rr-nudge__img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
            (p.image ? '<img src="' + esc(p.image) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '</a>' +
          '<div class="rr-nudge__meta">' +
            '<a class="rr-nudge__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<span class="rr-nudge__price">' + esc(p.price) + (closes ? ' <em>· ships free</em>' : '') + '</span>' +
          '</div>' +
          '<button type="button" class="rr-nudge__add" data-variant-id="' + esc(p.variantId) + '" data-title="' + esc(p.title) + '">' + esc(ADD_LABEL) + '</button>' +
        '</li>';
    }).join('');
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function open(cart) {
    render(cart);
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.body.classList.add('rr-nudge-open');
    document.addEventListener('keydown', onKey);
    var closeBtn = panel.querySelector('.rr-nudge__close');
    (closeBtn || panel).focus();
    if (!testMode) markSeen();
    try { window.posthog && posthog.capture('freeship_nudge_shown', { total_cents: cart.total_price, test: testMode }); } catch (e) {}
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('rr-nudge-open');
    document.removeEventListener('keydown', onKey);
    var done = function () { root.hidden = true; };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function goCheckout() { window.location.href = CHECKOUT_URL; }

  function addAndContinue(btn) {
    var id = Number(btn.getAttribute('data-variant-id'));
    if (!id) { goCheckout(); return; }
    if (testMode) {
      statusEl.hidden = false;
      statusEl.textContent = 'Test mode: would add "' + btn.getAttribute('data-title') + '" (variant ' + id + ') and continue to checkout.';
      return;
    }
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
    .then(function (res) {
      if (!res.ok) {
        btn.disabled = false; btn.textContent = ADD_LABEL;
        statusEl.hidden = false;
        statusEl.textContent = (res.body && res.body.description) || 'That item could not be added. You can still continue to checkout.';
        return;
      }
      try { window.posthog && posthog.capture('freeship_nudge_added', { variant_id: id }); } catch (e) {}
      goCheckout();
    })
    .catch(function () { btn.disabled = false; btn.textContent = ADD_LABEL; goCheckout(); });
  }

  /* --- wiring ------------------------------------------------------------ */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-rr-nudge-close]')) { e.preventDefault(); close(); return; }
    var add = e.target.closest('.rr-nudge__add');
    if (add) { e.preventDefault(); addAndContinue(add); return; }
    var cont = e.target.closest('#rr-nudge-continue');
    if (cont) {
      try { window.posthog && posthog.capture('freeship_nudge_declined'); } catch (err) {}
      if (testMode) { e.preventDefault(); statusEl.hidden = false; statusEl.textContent = 'Test mode: would continue to ' + CHECKOUT_URL + '.'; }
      /* real mode: let the anchor navigate to /checkout */
    }
  });

  function isCheckoutTrigger(el) {
    return el.closest('button[name="checkout"], .js-cart-btn-checkout, .rr-cart-drawer__checkout-btn, [data-rr-checkout]');
  }

  document.addEventListener('click', function (e) {
    var t = isCheckoutTrigger(e.target);
    if (!t || t.classList.contains('disabled')) return;
    if (seen()) return;                       /* already declined once this session */
    if (t.__rrNudgeBypass) { t.__rrNudgeBypass = false; return; }
    e.preventDefault(); e.stopPropagation();
    fetchCart().then(function (cart) {
      if (!cart.item_count || cart.total_price >= THRESHOLD) {
        /* no nudge: replay the original action. Only t.click() re-enters this
           same click listener (requestSubmit fires 'submit', not 'click', and
           a direct href/location change fires no DOM event on t at all) — so
           the bypass flag is only ever needed, and only ever cleared, on that
           one path. Setting it unconditionally left it dangling on the button
           for a.tagName === 'A' / requestSubmit, where nothing ever reads it
           again on this page — but a bfcache-restored page keeps that stale
           `true` around, so a later real click on the same button could skip
           the nudge even if the cart total has since dropped back below the
           threshold. */
        if (t.tagName === 'A') { window.location.href = t.getAttribute('href') || CHECKOUT_URL; }
        else if (t.form) {
          if (t.form.requestSubmit) { t.form.requestSubmit(t); }
          else { t.__rrNudgeBypass = true; t.click(); }
        }
        else { goCheckout(); }
        return;
      }
      open(cart);
    }).catch(function () {
      if (t.tagName === 'A') window.location.href = t.getAttribute('href') || CHECKOUT_URL; else goCheckout();
    });
  }, true);

  /* --- debug override ------------------------------------------------------ */
  var m = /[?&]rr_nudge_test=(\d+)/.exec(window.location.search);
  if (m) {
    testMode = true;
    var total = parseInt(m[1], 10);
    var fake = { item_count: 1, total_price: total, items: [{ handle: 'ceylon-cinnamon-powder', quantity: 1 }] };
    var run = function () {
      if (total >= THRESHOLD) {
        console.info('[rr-nudge] test total ' + total + ' >= threshold ' + THRESHOLD + ' — nudge correctly NOT shown');
        return;
      }
      open(fake);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  }
})();
